import { REF_FIREBASE, Cursor } from '@/services/firebase';
import _ from 'lodash';
import moment from 'moment';
const CONVERSATION_FB_REF = `messages/{0}`;
const MEMBERS_FB_REF = `members/{0}`;
const FIRST_MESSAGE_LOAD = 10;
const AMOUNT_MESSAGE_LOAD_MORE = 5;

export default {
    name: "MessageDetailsComponent",
    data() {
        return {
            id: '',
            conversationRef: null,
            membersRef: null,
            cursor: null,
            newMessage: '',
            members: [],
            messageList: [],
            myInfoFB: null,
            isLoadingMessage: false
        }
    },
    computed: {
        messageFilter() {
            return this.messageList.filter(item => item.message)
        }
    },
    filters: {
        displayTime: function (value) {
            return moment(value).format('hh:mm A');
        }
    },
    beforeDestroy() {
    },
    async created() {
        this.id = this.$route.params.id;
        this.isLoadingMessage = true;
        this.connectConversationWithFB();
        this.connectMemberRefWithFB();
        await this.getMemberList();
        this.loadMessageFromFB();
    },
    watch: {
        async $route(to, from) {
            if (to.params && to.params.id) {
                this.id = to.params.id;
                this.isLoadingMessage = true;
                this.connectConversationWithFB();
                this.connectMemberRefWithFB();
                await this.getMemberList();
                this.loadMessageFromFB();
            }
        }
    },
    methods: {
        groupMessage(newMessages, isHead) {
            let messageList = isHead ? [] : this.messageList;
            for(const mess of newMessages) {
                const lastMes = messageList.pop();
                if (lastMes && mess.userId === lastMes.sender.id) {
                    lastMes.messages.push(mess);
                    messageList.push(lastMes);
                } else {
                    if (lastMes) {
                        messageList.push(lastMes);
                    }
                    messageList.push({
                        messages: [mess],
                        sender: {id: mess.userId} // Todo: Update sender Info here
                    });
                }
            }
            if (isHead) {
                let last = messageList.pop();
                let first = this.messageList.shift();
                if (last.sender.id === first.sender.id) {
                    first.messages.push(...last.messages);
                    messageList.push(first);
                } else {
                    messageList.push(...[last, first]);
                }
                this.messageList.unshift(...messageList);
            } else {
                this.messageList = messageList;
            }
        },
        loadMessageFromFB() {
            this.cursor.next().then(res => {
                this.groupMessage(res);
                // Update read message
                if (res.length > 0) {
                    let lastItem = res[res.length - 1];
                    if (!lastItem.hasOwnProperty(this.myInfoFB.id)) {
                        this.cursor.setData(lastItem.key, this.myInfoFB.id, {isRead: true, status: 0});
                    }
                }
            });
        },
        connectMemberRefWithFB() {
            this.membersRef = REF_FIREBASE(MEMBERS_FB_REF.replace('{0}', this.id));
        },
        connectConversationWithFB() {
            this.cursor = new Cursor(CONVERSATION_FB_REF.replace('{0}', this.id), FIRST_MESSAGE_LOAD, this.handleNewMessageAdded);
            this.cursor.isExisted().then(result => {
                if (!result) {
                    this.$router.push({name: 'employee-message'});
                }
            });
        },
        handleLeaveMessage() {
            this.$router.push({name: 'employee-message'});
        },
        handleNewMessageAdded(message) {
            this.groupMessage([message]);
            if (!message.hasOwnProperty(this.myInfoFB.id)) {
                this.cursor.setData(message.key, this.myInfoFB.id, {isRead: true, status: 0});
            }
        },
        handleScrollAtTop() {
            this.isLoadingMessage = true;
            this.cursor.next(AMOUNT_MESSAGE_LOAD_MORE).then(res => {
                this.groupMessage(res, true);
                // this.messageList.unshift(...res);
                this.isLoadingMessage = false;
            });
        },
        handleSendNewMessage: _.debounce(function () {
            if (!this.newMessage) {
                return;
            }
            const messageObj = {
                createAt: new Date().getTime(),
                message: this.newMessage,
                userId: this.myInfoFB.id,
                [this.myInfoFB.id]: {isRead: true, status: 0}
            }
            this.cursor.addItem(messageObj).then(response => {
                console.log('Message sent successfully.');
                this.newMessage = '';
            }).catch(error => {
                console.log('Message sent failure.')
            });
        }, 300),
        async getMemberList() {
            await this.membersRef.once('value').then(snap => {
                const mapToArrayMember = (obj) => {
                    Object.keys(obj).forEach(key => {
                        this.members.push({
                            id: key,
                            info: obj[key]
                        });
                    })
                }
                mapToArrayMember(snap.val());
                let user = JSON.parse(localStorage.getItem('user'));
                this.myInfoFB = this.members.find(m => m.id.includes(user.pkAdv.toString()))
                if (!this.myInfoFB) {
                    this.$router.push({name: 'employee-message'});
                    return;
                }
            });
        }
    }
}
